module.exports = __webpack_public_path__ + "static/media/XXVe.230316d8.png";